export * from './baselayers-switcher.component';
export * from './mini-basemap.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/baselayers-switcher/index.ts